<template>
    <div>
            <div class="flex bottom8">
                <!--<el-radio-group v-model="c_type" @input="typeChange">
                    <el-radio :label='1'>收款</el-radio>
                    &lt;!&ndash;<el-radio :label='0'>付款</el-radio>&ndash;&gt;
                </el-radio-group>-->

                <el-date-picker style="width: 220px" class="marr4" size="mini"format="yyyy-MM-dd" value-format="yyyy-MM-dd"  v-model="searchTime"
                                @change="dateChange" :clearable="false" type="daterange" :range-separator="$t('form_to')" :start-placeholder="$t('form_start_date')" :end-placeholder="$t('form_end_date')">
                </el-date-picker>
                <el-select style="width: 90px" class="marr4" v-model="i_isuse" size="mini" >
                    <el-option v-for="item in stateList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select style="width: 90px" class="marr4" v-model="i_dealstatus" size="mini" >
                    <el-option v-for="item in chuliList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select style="width: 90px" class="marr4" v-model="vc_cancel_status" size="mini" >
                    <el-option v-for="item in chList" :key="item.vc_name" :label="item.vc_nameshow" :value="item.vc_name">
                    </el-option>
                </el-select>
                <el-select style="width: 145px" @change="changegs"  class="marr4" v-model="i_gsid" size="mini" :placeholder="$t('form_please_select_a_company')" >
                    <el-option v-for="item in gsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select  style="width: 100px"  class="marr4" v-model="i_bzid" size="mini"  :placeholder="$t('collectPayment_please_select_currency')">
                    <el-option
                            v-for="item in bzList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
                <el-select style="width: 145px"  class="marr4" v-model="vc_bank_account" size="mini" clearable filterable :placeholder="$t('collectPayment_please_select_a_bank_account_number')">
                    <el-option v-for="item in yhzhList" :key="item.vc_bank_account" :label="item.vc_bank_account" :value="item.vc_bank_account">
                    </el-option>
                </el-select>
                <el-select style="width: 145px"  class="marr4" v-model="i_khid" size="mini" remote :remote-method="remoteMethodkh" filterable :placeholder="c_type==1?$t('collectPayment_please_select_a_customer'):$t('collectPayment_please_select_a_supplier')">
                    <el-option v-for="item in khList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>

<!--                <el-select style="width: 145px" v-if="type==1" class="marr4" v-model="gysid" size="mini" clearable filterable placeholder="请选择供应商">-->
<!--                    <el-option v-for="item in gysList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">-->
<!--                    </el-option>-->
<!--                </el-select>-->
                <el-select style="width: 75px" class="marr4" v-model="i_sktype" size="mini" >
                    <el-option v-for="item in dhcdList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
                <el-input style="width: 120px" class="marr4" clearable size="mini" :placeholder="$t('collectPayment_search_for_bill_of_exchange_number_input_person_remarks')"  v-model="vc_search">
                </el-input>
                <el-button class="mrl20" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
                <el-button class="mrl20" icon="el-icon-refresh" circle  @click="clearSearchData" size="mini"></el-button>
            </div>
            <div class="flex bottom8">

                <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="addnew">{{$t('button_newly_added')}}</el-button>
                <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="LStongji">{{$t('collectPayment_flow_statistics')}}</el-button>
                <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="tongji">{{$t('collectPayment_accounts_receivable_statistics')}}</el-button>
            </div>


        <el-table
                class="mrt10"
                ref="table"
                size="mini"
                :height="tableHeight"
                border
                :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="true"
                style="width: 100%;margin-right: 9px;margin-left: 9px">
            <el-table-column  :label="$t('form_serial_number')" align="center" type="index" width="45px"></el-table-column>
            <el-table-column align="center" :label="$t('collectPayment_payment_date')" prop="dt_paytime" width="85px" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('collectPayment_payment_method')" width="80px" prop="vc_sktype"  show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('collectPayment_main_number_of_the_bill_of_exchange')"prop="vc_hpcode"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('collectPayment_bill_sub_number')" prop="vc_subcode"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('form_currency')" width="60px" prop="vc_bzname"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('form_exchange_rate')" width="75px" prop="f_rate"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('collectPayment_payment_amount')" prop="f_pay"    show-overflow-tooltip>
                <template slot-scope="scope">
                    <div style="text-align: right">{{scope.row.f_pay}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('form_notes')" prop="vc_note"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('collectPayment_customer_name')" prop="vc_khname"    show-overflow-tooltip>
                <template slot-scope="scope">
                    <div style="width: inherit"><span v-if="scope.row.i_khid===-1" style="color: #e1962b">{{'('+$t('state_pending')+')'}}</span><span v-if="scope.row.i_khid===0" style="color: red">{{'('+$t('state_to_be_improved')+')'}}</span>{{scope.row.vc_khname}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('form_corporate_name')" prop="vc_gsname"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('collectPayment_bank_account_number')" prop="vc_gsaccount"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('form_input_person')" width="80px" prop="vc_lruname"   show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('collectPayment_entry_method')" width="80px" prop="vc_source"   show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('collectPayment_registration_date')" prop="dt_createtime" width="90px"  show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('collectPayment_type')" prop="vc_fytype"   width="70px"  show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('form_status')" prop="vc_isuse" width="50px"  show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('collectPayment_red_status')" prop="vc_cancel_status"    show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('form_operate')" prop="f_txlv1"  show-overflow-tooltip width="60px">
                <template slot-scope="scope">
                    <el-button  size="mini"  v-if="scope.row.i_khid===0" type="text" @click="detail(scope.row)">{{$t('button_edit')}}</el-button>
                    <el-button style="color:red;" :disabled="disabled" v-if="scope.row.i_isuse==1&&scope.row.vc_cancel_status=='未冲红'&&(scope.row.i_sktype==3||scope.row.i_sktype==2&&scope.row.vc_hpstatus=='持票'||scope.row.i_sktype==2&&scope.row.i_source==0)" type="text" size="mini" @click="nullifyFun(scope.row)">{{$t('collectPayment_write_off_in_red')}}</el-button>

                    <!--                    <el-button  v-if="scope.row.i_khid===-1" type="text" @click="hexiao(scope.row)">核销</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  style="margin-top: 10px;text-align: right"
                        background
                        @current-change="pageCurrentChange"
                        @size-change="sizeChange"
                        :page-sizes="[20,50,100]"
                        layout="total,sizes,prev, pager, next"
                        :current-page.sync="currentPage"
                        :total="total"
                        :page-size="pageSize">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog
                    class="cldialog"
                    style="display: flex;justify-content: center;align-items: center;"
                    width="680px"
                    top="30"
                    height="300"
                    :title="c_type==1?$t('collectPayment_payment_collection'):$t('collectPayment_payment')"
                    :visible.sync="detailDialog"
                    v-if="detailDialog"
                    :close-on-click-modal="false" @close="detailClose">
                <detail-page :data="detailData" @close="detailClose"></detail-page>
            </el-dialog>
            <el-dialog
                    class="cldialog"
                    style="display: flex;justify-content: center;align-items: center;"
                    width="780px"
                    top="30"
                    height="300"
                    :title="c_type==1?$t('collectPayment_payment_collection'):$t('collectPayment_payment')"
                    :visible.sync="hxDialog"
                    v-if="hxDialog"
                    :close-on-click-modal="false" @close="hxClose">
                <hx-page :data="hxData" @close="hxClose"></hx-page>
            </el-dialog>
        </div>
        <reportdialog  ref="mydialog"  ></reportdialog>
        <eDialog ref="eDialog" :activePage="activePage"></eDialog>
    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import DetailPage from "./DetailPage"
    import HxPage from "./HxPage"
    import {baseerp} from "@/utils/baseUrl";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog

    export default {
        name: "index",
        components: {
            DetailPage,
            HxPage,
            eDialog,
            reportdialog,
        },
        data() {
            return {
                loading:true,
                activePage:"report/res/spread.vue",
                mid:0,
                c_type:1,
                tableHeight:0,
                baseerp:'',
                tableData:[],
                currentPage: 1,
                pageSize: 20,
                total:0,
                detailData:{},
                detailDialog:false,
                hxData:{},
                hxDialog:false,
                detailTitle:this.$t('button_newly_added'),
                gsList:[],
                i_gsid:0,
                bzList:[],
                i_bzid:1,
                searchTime:[],
                vc_search:'',
                yhzhList:[],
                vc_bank_account:'',
                khList:[],
                i_khid:0,
                i_sktype:0,
                dhcdList:[{i_id:2,vc_name:this.$t('collectPayment_acceptance')},{i_id:3,vc_name:this.$t('collectPayment_telegraphic_transfer')},{i_id:0,vc_name:this.$t('state_all')}],
                i_isuse:1,
                i_dealstatus:-1,
                stateList:[{i_id:1,vc_name:this.$t('collectPayment_effective')},{i_id:0,vc_name:this.$t('state_invalid')},{i_id:-1,vc_name:this.$t('state_all')}],
                chuliList:[{i_id:-1,vc_name:this.$t('state_all')},{i_id:0,vc_name:this.$t('state_pending')},{i_id:1,vc_name:this.$t('state_to_be_improved')}],
                vc_cancel_status:'未冲红',
                chList:[{vc_name:'全部',vc_nameshow:this.$t('state_all'),},
                    {vc_name:'已冲红',vc_nameshow:this.$t('collectPayment_pay_already_flushed_red')},
                    {vc_name:'冲红流水',vc_nameshow:this.$t('collectPayment_pay_flowing_red_water'),},
                    {vc_name:'未冲红',vc_nameshow:this.$t('collectPayment_pay_not_flushed_red'),}],
                searchkh:'',
                disabled:false,
            }
        },
        watch: {

            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.getDay();
            this.getbzlist();
            this.getKhlistWithNoRights();
            this.getCompanyList();
            this.getHistoryPayment();
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-150

            },
            nullifyFun(row){
                this.$confirm(this.$t('collectPayment_do_you_want_to_continue_flushing_red'),this.$t('tips_prompt'),{
                    // this.$confirm(this.$t('companyManageMD_do_you_want_to_these_pieces_of_data',[typename,tableData.length]),this.$t('tips_prompt'),{
                    confirmButtonText: this.$t('button_sure'),
                    cancelButtonText: this.$t('button_cancel'),
                    type:"warning"
                }).then(()=>{
                    // this.disabled=true
                    this.cancelBillDetail(row)
                }).catch(()=>{
                    this.$message.info(this.$t('tips_cancel_operation'))
                })

            },
            LStongji(){
                if(this.i_gsid==0){
                    this.$message.error(this.$t('collectPayment_please_select_a_company_first'));
                    return;
                }
                let loading =this.$loading({lock:true,text:this.$t('tips_loading_data_please_wait'),background:"rgba(0,0,0,0.5)"});
                this.$refs.eDialog.showDialog({
                    title:this.$t('button_export'),
                    parm:{type:'bankStatementRpt',
                        mid:this.$route.meta.mid,
                        arg:{
                            endDate:this.endDate,
                            startDate:this.startDate,
                            i_gsid:this.i_gsid,
                            i_khid:this.i_khid,
                            vc_bank_account:this.vc_bank_account,
                            i_bzid:this.i_bzid,
                        }},
                    w:1024,h:768});
                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                })
            },

            dateChange(){
                this.startDate=this.searchTime[0]
                this.endDate=this.searchTime[1]
                this.currentPage=1;
                this.getHistoryPayment();
            },
            changegs(){
                this.vc_bank_account=''
                this.yhzhList=[]
                if(this.i_gsid){
                    this.getAccountByGsid()

                }
            },
            typeChange(){
                this.getKhlistWithNoRights()
            },
            addnew(){


                this.detailData={
                    i_id:0,
                    "c_type": this.c_type,
                };
                this.detailDialog=true;
            },
            detail(item){
                this.detailData=item
                this.detailDialog=true;
            },
            hexiao(item){
                this.hxData=item;
                this.hxDialog=true;
            },
            tongji(){
                if(this.i_gsid==0){
                    this.$message.error(this.$t('collectPayment_please_select_a_company_first'));
                    return;
                }
                let loading =this.$loading({lock:true,text:this.$t('tips_loading_data_please_wait'),background:"rgba(0,0,0,0.5)"});
                this.$refs.eDialog.showDialog({
                    title:this.$t('button_export'),
                    parm:{
                        type:'receivableRpt',
                        mid:this.$route.meta.mid,
                        arg:{
                            i_gsid:this.i_gsid,
                            i_khid:this.i_khid,
                            i_bzid:this.i_bzid,
                        }},
                    w:1024,h:768});
                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                })
            },
            detailClose(type='back'){
                if(type=='save'){
                    this.currentPage=1
                    this.getHistoryPayment()
                }
                this.detailDialog=false;

            },
            hxClose(type='back'){
                if(type=='save'){
                    this.currentPage=1
                    this.getHistoryPayment()
                }
                this.hxDialog=false;

            },
            gosearch(){
                this.currentPage=1
                this.getHistoryPayment()
            },
            clearSearchData(){
                this.i_gsid=0;
                this.i_khid=0;
                this.i_bzid=1;
                this.i_sktype=0;
                this.vc_bank_account='';
                this.vc_search='';
                this.i_isuse=1;
                this.i_dealstatus=-1;
                this.currentPage=1;
                this.getHistoryPayment()
            },
            remoteMethodkh(val){
                this.searchkh=val
                this.getKhlistWithNoRights()
            },
            async getKhlistWithNoRights(){
                let param={
                    i_khtype:this.c_type==0?2:1,
                    currentPage:1,
                    pageSize: 50,
                    vc_search: this.searchkh,
                };
                let res=await API.getKhlistWithNoRights(param);
                if ( res.code == 1 ){
                    this.khList=res.data.list;
                    this.khList.unshift({i_id:0,vc_name:this.c_type==1?this.$t('collectPayment_all_customers'):this.$t('collectPayment_all_suppliers')})
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_type:'0,2',
                    i_mid:this.mid,
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.gsList=res.data;
                    this.gsList.unshift({i_id:0,vc_name:this.$t('collectPayment_all_companies')})
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getAccountByGsid(){
                let param={
                    i_gsid:this.i_gsid,
                };
                let res=await API.getAccountByGsid(param);
                if ( res.code == 1 ){
                    this.yhzhList=res.data.accountList;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async cancelBillDetail(row){
                let param={
                    i_id:row.i_id,
                    i_source:row.i_source,
                    i_isbankcharges:row.i_isbankcharges,
                    c_type:row.c_type,
                };
                let res=await API.cancelBillDetail(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message);
                    this.getHistoryPayment()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getHistoryPayment(){
                this.disabled=true
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_mid:this.mid,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    endDate:this.endDate,
                    startDate:this.startDate,
                    i_gsid:this.i_gsid,
                    i_khid:this.i_khid,
                    i_sktype:this.i_sktype,
                    vc_bank_account:this.vc_bank_account,
                    vc_search:this.vc_search,
                    i_isuse:this.i_isuse,
                    i_dealstatus:this.i_dealstatus,
                    c_type:this.c_type,
                    i_bzid:this.i_bzid,
                    vc_cancel_status:this.vc_cancel_status=='全部'?'':this.vc_cancel_status,


                };
                let res=await API.getHistoryPayment(param);
                if ( res.code == 1 ){
                    this.tableData=res.data.list;
                    this.total=res.data.total
                    this.disabled=false

                }else if (res.code == -2) {
                    this.disabled=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.disabled=false
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getHistoryPayment();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getHistoryPayment();
            },
            getDay(){
                const date=new Date();
                const y=date.getFullYear()
                const m=(date.getMonth()+1).toString().padStart(2,'0');
                const prem=date.getMonth().toString().padStart(2,'0');
                const d=date.getDate().toString().padStart(2,'0');
                this.startDate=y+'-'+m+'-'+'01';
                this.endDate=y+'-'+m+'-'+d;
                this.preMDate=y+'-'+prem+'-'+d;
                this.searchTime=[ this.startDate,this.endDate]
            },
            async getbzlist(){
                let param={

                };
                let res=await API.getbzlist(param);
                if ( res.code == 1 ){
                    this.bzList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
        align-items: center;
        flex-wrap:wrap ;

    }
    .bottom8{
        margin: 8px;
    }
    .el-radio{
        margin-right: 10px;
    }
</style>